export default {
  title: "Documents",
  missing: "Missing: {{names}}",
  expiredLine: "Expired: {{names}}",
  allSet: "All required documents are in",
  noOpen: "You see the status only. Opening files needs access to sensitive driver data.",
  addOther: "Other document",
  otherName: "Document name",
  chooseFile: "Choose file",
  changeFile: "Change file",
  accepted: "Photo (JPEG, PNG, HEIC) or PDF, up to 20 MB",
  requiredTag: "Required",
  currentTag: "Current",
  uploading: "Uploading…",
  uploaded: "Document uploaded",
  requestedToast: "Request noted",
  reminderFor: "Reminder for {{name}} tomorrow",
  archived: "Document archived",
  failed: "Could not save the document",
  tooLarge: "The file is too large (max {{mb}} MB). Take a regular photo or compress the PDF.",
  conflict: "Someone changed this document a moment ago. The list is refreshed — try again.",
  versions: "Previous versions ({{count}})",
  by: "by {{name}}",
  expires: "valid until {{date}}",
  pages: "{{count}} pages",
  status: {
    missing: "Not uploaded",
    requested: "Requested {{when}}",
    received: "Uploaded {{when}}",
    expiring: "expires in {{count}} days",
    expired: "expired {{date}}",
  },
  statusName: { missing: "Missing", requested: "Requested", received: "Received", expiring: "Expiring soon", expired: "Expired" },
  actions: {
    upload: "Upload",
    newVersion: "New version",
    request: "Request",
    requested: "Requested",
    open: "Open",
    download: "Download",
    editDates: "Edit dates",
    archive: "Archive",
    more: "More",
    reread: "Read again with AI",
    uploadAnother: "Upload another copy",
  },
  archiveConfirm: {
    title: "Archive {{label}}?",
    description: "The file stays in previous versions; the type shows as missing until a new file is uploaded.",
  },
  dates: { title: "Document dates", issued: "Issued", expires: "Valid until", save: "Save", cancel: "Cancel", saved: "Dates saved", state: "CDL state", statePlaceholder: "TX" },
  viewer: { status: "Status", uploaded: "Uploaded", requested: "Requested", ocr: "AI reading", archivedNote: "Previous version · archived {{date}}", state: "State" },
  ocr: {
    pending: "Reading…",
    done: "Read by AI",
    suggest: "AI suggestion",
    failed: "Could not read",
    queued: "Reading again…",
    title: "Read from the document",
    modelLine: "Read by {{model}}. Nothing changes until you accept.",
    dismiss: "Dismiss",
    close: "Close",
    accept: "Accept ({{count}})",
    applied: "Applied to the profile",
    dismissed: "Suggestion dismissed",
    skipped: "Skipped (needs sensitive-data access): {{fields}}",
    nothing: "No fields were read from this document.",
    kindMismatch: "This looks like a different document: {{kind}}.",
    nameMismatch: "The name on the document differs from the profile.",
    sensitive: "needs sensitive-data access",
    lowConfidence: "check",
    same: "same",
    cols: { field: "Field", profile: "Profile", document: "Document" },
  },
  fields: {
    first_name: "First name",
    last_name: "Last name",
    date_of_birth: "Date of birth",
    cdl_number: "CDL number",
    cdl_class: "CDL class",
    cdl_state: "CDL state",
    cdl_expires: "CDL expires",
    medical_card_expires: "Medical card expires",
    endorsements: "Endorsements",
  },
  kinds: {
    cdl: "CDL (front and back)",
    medical_card: "Medical card",
    application: "Application form",
    mvr: "MVR",
    psp: "PSP report",
    other: "Other document",
  },
  preview: {
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    fit: "Fit to window",
    rotate: "Rotate",
    prev: "Previous document",
    next: "Next document",
    textLayer: "Show text on the image",
    copyHint: "Click a line on the image or in the list to copy it.",
    copied: "Copied",
    copyFailed: "Could not copy",
    noText: "No text has been read from this image yet.",
    reading: "Reading the text…",
    readFields: "Read from the document",
    lines: "Text on the image",
    pdfHint: "Select text in the PDF to copy it.",
    of: "{{n}} of {{total}}",
    copyLine: "Copy: {{text}}",
  },
  docFields: { full_name: "Full name", issued_at: "Issued", expires_at: "Valid until", restrictions: "Restrictions", examiner_name: "Examiner", registry_number: "Registry number" },
  overview: { open: "Open documents" },
};
